import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	label: {
		id: 'issue-table-inline-issue-create.inline-create-from.issue-type-dropdown.label',
		defaultMessage: 'Issue type',
		description: 'Label to be set on the issue type dropdown element',
	},
});
